export default __webpack_public_path__ + "feedback-module-empty-heading.png";